import(/* webpackMode: "eager" */ "/Users/juancartagena/foundry/neotral/apps/web-app/src/app/medios/[id]/page.tsx");
